/**
 * "My shifts" inside the office portal, for directors and admins whose login is linked to a crew
 * record (people who run the business and also work on site): their own shifts and job packs, with
 * the same signing, checklists and reports as crew. Routes: #/my and #/my/<booking id>.
 */
import { hashParams, useHash } from "../../lib/route";
import { MyShifts, PackView } from "../../screens/CrewPack";

export function MyShiftsScreen() {
  const [id] = hashParams(useHash());
  return (
    <section className="page" aria-labelledby="page-title" style={{ maxWidth: 760 }}>
      {id ? <PackView key={id} bookingId={id} backHref="#/my" backLabel="My shifts" /> : <MyShifts linkBase="#/my" />}
    </section>
  );
}

/** The one-tap link on the portal home for staff who also work on site. */
export function MyShiftsLink() {
  return (
    <a className="btn btn--primary btn--block myshifts-link" href="#/my">
      My shifts and job packs
    </a>
  );
}
